import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Injector, ProviderToken } from '@angular/core';
import { AlertService, ErrorStateService } from '@app-core';
import { catchError, Observable, throwError, EMPTY, of } from 'rxjs';
import { ErrorResponseHandlerMapConstant } from '../error-response-handler-map.constant';
import { GlobalConstants } from '../global-constants';
import { BaseErrorHandlerModel } from '../interface/error-handler.interface';
import { ErrorCode, ExtendedServerErrorResponse } from '../interface/http-response.interface';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private readonly injector = inject(Injector);
    private readonly alertService = inject(AlertService);
    private readonly errorStateService = inject(ErrorStateService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse | ExtendedServerErrorResponse) => {
                this.errorStateService.lastError = error;
                if (error instanceof HttpErrorResponse) {
                    if (error.error instanceof ProgressEvent) {
                        this.errorStateService.setProgressEventErrorOccurred();
                        this.handleError(ErrorCode.ProgressEvent, error);
                    } else {
                        // Handle other errors
                        this.alertService.clearAlerts();
                        this.handleError(error.error?.errorCode ?? error.status, error);
                    }
                }
                return throwError(() => error);
            }),
        );
    }

    private handleError(errorCode: ErrorCode, error: HttpErrorResponse | ExtendedServerErrorResponse) {
        const providerToken: ProviderToken<BaseErrorHandlerModel> = ErrorResponseHandlerMapConstant[errorCode] ?? ErrorResponseHandlerMapConstant[ErrorCode.Default];
        const handler = this.injector.get(providerToken);
        handler.handle(error);
    }
}
